import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  QuestionTransparent,
} from '@picsio/ui/dist/icons';
import { IconButton, Button } from '@picsio/ui';
import Logger from '../../services/Logger';
import localization from '../../shared/strings';
import Tooltip from '../Tooltip';
import picsioConfig from '../../../../../config';

/**
 * Help button component
 * @param {string} tooltipPosition
 * @param {string} component
 * @returns {JSX}
 */
const HelpButton = ({
  additionalClass = '',
  tooltipPosition = '',
  component = '',
  externalUrl = '',
  event = 'Help',
  text = null,
  onClick = null,
  startIcon = <QuestionTransparent />,
  onClickHandler = null,
}) => {
  const path = localization.HELP_CENTER[component]?.url;
  const baseUrl = !picsioConfig.isPim ? 'https://help.pics.io/' : 'https://help.toriut.com/';
  const tooltipText = !picsioConfig.isPim ? localization.HELP_CENTER[component]?.tooltip : localization.HELP_CENTER_TORIUT[component]?.tooltip;
  const tooltipContent = !text ? tooltipText : '';

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
      return;
    }

    if (onClickHandler) {
      onClickHandler();
    }
    window.open(`${path ? `${baseUrl}${path}` : externalUrl}`, '_blank');
    Logger.log('User', event, component);
  }, [onClick, onClickHandler, path, baseUrl, externalUrl, event, component]);

  return (
    <Tooltip content={tooltipContent} placement={tooltipPosition}>
      <Choose>
        <When condition={text}>
          <Button
            className={cn('importHelpButton', { [additionalClass]: additionalClass })}
            id="button-help"
            variant="text"
            color="primary"
            size="lg"
            startIcon={startIcon}
            onClick={handleClick}
          >
            {text}
          </Button>
        </When>
        <Otherwise>
          <IconButton
            id="button-help"
            className={cn('toolbarButton', { [additionalClass]: additionalClass })}
            additionalClass={additionalClass}
            onClick={handleClick}
            size="lg"
          >
            {startIcon}
          </IconButton>
        </Otherwise>
      </Choose>
    </Tooltip>
  );
};

HelpButton.propTypes = {
  text: PropTypes.string,
  additionalClass: PropTypes.string,
  tooltipPosition: PropTypes.string,
  component: PropTypes.string,
  externalUrl: PropTypes.string,
  event: PropTypes.string,
  onClick: PropTypes.func,
  startIcon: PropTypes.node,
  onClickHandler: PropTypes.func,
};

export default HelpButton;
